/** Teammate tools that show the approval card only from APPROVAL_FROM records. */
export const Teammate = {
  COUNTED_APPROVAL_TOOLS: [
    'push_to_crm',
    'push_search_results_to_crm',
    'bulk_push_list_to_crm',
    'bulk_get_companies',
    'bulk_get_people',
    'bulk_reveal_person_emails',
    'bulk_reveal_person_phones',
  ],
  APPROVAL_FROM: 100,
};
